import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import activateIntercom from '{src}/javascripts/sharedWithConsole/afterLoginDataFetch/utils/activateIntercom.ts'
import { bootIntercom } from '{src}/javascripts/sharedWithConsole/intercom-facade/boot-intercom.ts'
import { useLoginData } from '~/features/authentication/data.ts'

export function ActivateIntercom() {
  const { data } = useLoginData()
  const location = useLocation()

  useEffect(() => {
    if (!data?.login_data) return
    activateIntercom(data?.login_data)

    bootIntercom(false)
  }, [data, location])

  return null
}
